import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Tv, Radio, MonitorPlay, ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "./motion";
import { useTranslate } from "../context/TranslateContext";
import { getSeries } from "../mock/tv";

const CARDS = [
  { to: "/television", label: "Television", icon: Radio, blurb: "Channels, prime-time serials, reality & classics across every language.", series: "ashiyana", accent: "#C0392B" },
  { to: "/tv-serials", label: "TV Serials", icon: Tv, blurb: "Follow daily serials episode by episode — no seasons required.", series: "kaanal", accent: "#2FA8A0" },
  { to: "/ott", label: "OTT & Streaming", icon: MonitorPlay, blurb: "Originals, web series and films arriving from cinemas.", series: "mumbai-undercover", accent: "#3B6EA5" },
];

export const EntertainmentTeaser = () => {
  const { t } = useTranslate();
  const listenText = "Beyond the big screen. IndiasCinema now spans Indian Television, TV serials and OTT streaming — discover channels, follow daily serials and find where to watch, all in one place.";

  return (
    <section id="entertainment" className="relative border-y border-edge bg-surface/30 py-28 md:py-40">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="mb-14 flex flex-wrap items-end justify-between gap-6">
          <div className="max-w-2xl">
            <Overline>Cinema · Television · OTT</Overline>
            <h2 className="mt-4 font-display text-4xl font-semibold leading-tight tracking-tight text-cream md:text-6xl">
              {t("Beyond the ")}<span className="italic text-gradient-gold">{t("big screen")}</span>
            </h2>
            <p className="mt-4 font-body text-lg text-ash">{t("Discover, follow and discuss Indian television and streaming — the same knowledge graph, now across every screen.")}</p>
          </div>
          
        </div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {CARDS.map((c, i) => { const s = getSeries(c.series); const Icon = c.icon; return (
            <Reveal key={c.to} delay={i * 0.08}>
              <Link to={c.to} data-testid={`teaser-${c.to.slice(1)}`}>
                <motion.div whileHover={{ y: -8 }} transition={{ duration: 0.4 }}
                  className="group relative h-[26rem] overflow-hidden rounded-3xl border border-edge">
                  <img src={s?.poster} alt={c.label} className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <div className="absolute inset-0" style={{ background: `linear-gradient(180deg, ${c.accent}22 0%, rgba(15,11,13,0.55) 40%, #0F0B0D 100%)` }} />
                  <div className="absolute inset-x-0 bottom-0 p-7">
                    <span className="inline-flex items-center gap-2 rounded-full border px-3 py-1 font-body text-xs" style={{ borderColor: c.accent + "88", color: c.accent, background: c.accent + "1a" }}>
                      <Icon className="h-3.5 w-3.5" /> {t(c.label)}
                    </span>
                    <h3 className="mt-4 flex items-center gap-2 font-display text-3xl font-semibold text-paper drop-shadow-lg">{t(c.label)} <ArrowUpRight className="h-6 w-6 opacity-0 transition-opacity duration-300 group-hover:opacity-100" style={{ color: c.accent }} /></h3>
                    <p className="mt-2 font-body text-sm text-paper/80">{t(c.blurb)}</p>
                  </div>
                </motion.div>
              </Link>
            </Reveal>
          ); })}
        </div>
      </div>
    </section>
  );
};
